import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from "@angular/core";
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from "@angular/router";
import Aura from '@primeuix/themes/aura';
import { provideHighlightOptions } from 'ngx-highlightjs';
import { provideMarkdown } from "ngx-markdown";
import { authInterceptor } from "@shared-angular/interceptors/auth.interceptor";
import { httpConcurrencyInterceptor } from "@shared-angular/interceptors/http-concurrency.service";
import { httpErrorInterceptor } from "@shared-angular/interceptors/http-error.interceptor";
import { httpLoggerInterceptor } from "@shared-angular/interceptors/http-logger.interceptor";
import { FrontendUrlsService } from "@shared-angular/services/frontend-urls.service";
// eslint-disable-next-line no-restricted-imports
import { provideToastr } from "ngx-toastr";
import { providePrimeNG } from 'primeng/config';
import { routes } from "./app-routing.module";
export const appConfig: ApplicationConfig = {
  providers: [
    providePrimeNG({
      license: "eyJpZCI6IjVmM2VkMTFmLTdlYjUtNGU2Zi04NGVkLTllZTU2ODY4OTE4OSIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW1lcmNpYWwiLCJ0eXBlIjoiZGV2IiwiaWF0IjoxNzkwMDYzMDA5LCJleHAiOjE4MjE1OTg0ODR9.Sjd73vdaF3nvGMu_Y6xAyQeNzN_6BfEZYnQ9KVzuF83Y7HCZY7yKAuu4aMLTXozfFBtcBTVoiL_OE-SDovfcCw",
      zIndex: {
        modal: 1100,
        overlay: 10200,
        menu: 1200,
        tooltip: 1300
      },
      overlayOptions: {
        appendTo: 'body'
      },
      theme: {
        options: {
          darkModeSelector: '.dark-mode',
          progressspinner: {
            root: {
              colorOne: "#110011"
            }
          }
        },
        preset: Aura
      }
    }),
    provideAnimationsAsync(),
    provideHighlightOptions({
      fullLibraryLoader: () => import('highlight.js')
    }),
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([httpLoggerInterceptor, authInterceptor, httpErrorInterceptor, httpConcurrencyInterceptor])),
    provideAppInitializer(() => inject(FrontendUrlsService).load()),
    provideToastr({
      preventDuplicates: true,
      countDuplicates: true,
      includeTitleDuplicates: true,
      resetTimeoutOnDuplicate: true,
      progressBar: true,
      timeOut: 2000
    }),
    provideMarkdown()
  ]
};
